import { render, staticRenderFns } from "./member-costs.vue?vue&type=template&id=5d17be38&scoped=true"
import script from "./member-costs.vue?vue&type=script&lang=js"
export * from "./member-costs.vue?vue&type=script&lang=js"
import style0 from "./member-costs.vue?vue&type=style&index=0&id=5d17be38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17be38",
  null
  
)

export default component.exports